export function getFirstAndLast<T> (arr: Array<T>): Array<T> {
  const result = []

  if (arr.length > 0) {
    result.push(arr[0])
  }

  if (arr.length > 1) {
    result.push(arr[arr.length - 1])
  }

  return result
}

export function arrayWalkRecursive(theArray: any, theWalkCallback: (theObject: any, theIndex: string, theParent: any) => any) : any {
  for (const key in theArray) {
    if (theArray.hasOwnProperty(key)) {
      if (theArray[key] !== null && typeof theArray[key] === 'object') {
        theWalkCallback(theArray[key], key, theArray)
        arrayWalkRecursive(theArray[key], theWalkCallback)
      }
    }
  }
}
